import React, {useCallback, useEffect, useState} from 'react'
import {State} from '../../../../../store/ducks'
import {connectComponent} from '../../../../../store/common'
import {
  ClientDTO,
  MenuCategoryDTO,
  ProductMap,
  PushClientDTO,
  RestaurantByProductMap,
} from 'grilnica-store-share'
import {CityDTO, getItemByKey} from 'grilnica-share'
import {ProductDTO} from 'grilnica-store-share/lib/product/ProductDTO'
import {IsShowRestaurantByProductMap} from '../../../../../types/restaurantProduct/IsShowRestaurantByProductMap'
import {getRestaurantByProductMapService} from '../../../../../services/restaurantProduct'
import {NotificationPageComponent} from './NotificationPageComponent'
import {bindPushActions} from '../../../../../store/push/duck'
import {PushActionsType} from '../../../../../store/push/duck/actions'
import {BasketActionsType, bindBasketActions} from '../../../../../store/ducks/basket'

interface NotificationPageProps {
  history?: any
  productMap: ProductMap
  isShowRestaurantByProductMap: IsShowRestaurantByProductMap
  categoryList: MenuCategoryDTO[]
  selectedCity: CityDTO
  pushActions: PushActionsType
  basketActions: BasketActionsType

  pushQueueId: string
  client: ClientDTO
  messages: PushClientDTO[]
}

const NotificationPage: React.FC<NotificationPageProps> = ({
  history,
  productMap,
  isShowRestaurantByProductMap,
  categoryList,
  selectedCity,
  client,
  pushActions,
  basketActions,
  pushQueueId,
  messages,
}): React.ReactElement => {
  const [message, setMessage] = useState<PushClientDTO | undefined>(undefined)
  const [restaurantByProductMap, setRestaurantByProductMap] = useState<RestaurantByProductMap>(null)

  const checkIsAddProduct = useCallback(
    (productProp: ProductDTO): ProductDTO => {
      for (let item of productMap[productProp.menuCategoryId] || []) {
        if (
          isShowRestaurantByProductMap[productProp.productId] !== undefined &&
          item.productId === productProp.productId &&
          (item.price || item.salePrice || item.isShowWithZeroPrice) &&
          !item.isHideInApp
        ) {
          return item
        }
      }
      return undefined
    },
    [isShowRestaurantByProductMap, productMap],
  )

  const getRestaurantByProduct = useCallback(async () => {
    const {cityId} = selectedCity
    if (cityId) {
      let newRestaurantByProductMap: RestaurantByProductMap
      newRestaurantByProductMap = await getRestaurantByProductMapService(cityId)
      setRestaurantByProductMap(newRestaurantByProductMap)
    }
  }, [selectedCity])

  const loadData = useCallback(async (): Promise<void> => {
    const loadedMessage = getItemByKey<PushClientDTO>('pushQueueId', messages, pushQueueId)
    if (loadedMessage) {
      setMessage({...loadedMessage})
    }

    await getRestaurantByProduct()
  }, [getRestaurantByProduct, messages, pushQueueId])

  useEffect(() => {
    if (!!pushQueueId && !!messages && !!categoryList) {
      loadData()
    }
  }, [pushQueueId, messages, categoryList, loadData])

  useEffect(() => {
    if (!!pushQueueId && !!message && !message?.readDate) {
      pushActions.readPushMessageRequest(pushQueueId)
    }
  }, [pushQueueId, message?.readDate, message, pushActions])

  const goBack = () => {
    history.goBack()
  }

  const hidePushMessage = () => {
    pushActions.hidePushMessageRequest(message.pushQueueId)
  }

  const addCouponOrCouponAndProducts = () => {
    // Добавление купона в корзину или добавление купона в корзину и товаров(с опциями и продукт вариантом по умолчанию)
    basketActions.addCouponOrCouponAndProductsInBasketRequest(message)
  }

  if (!!client && !!pushQueueId) {
    return (
      <NotificationPageComponent
        message={message}
        categoryList={categoryList}
        productMap={productMap}
        restaurantByProductMap={restaurantByProductMap}
        hidePushMessage={hidePushMessage}
        addCouponOrCouponAndProducts={addCouponOrCouponAndProducts}
        goBack={goBack}
        checkIsAddProduct={checkIsAddProduct}
      />
    )
  } else {
    return null
  }
}

export default connectComponent(
  (state: State, props) => ({
    pushQueueId: props.match.params.pushQueueId,
    client: state.auth.client,
    messages: state.push?.messages,
    categoryList: state.menu.categoryList,
    selectedCity: state.city.selectedCity,
    productMap: state.menu.productMap,
    isShowRestaurantByProductMap: state.restaurantProduct.isShowRestaurantByProductMap,
  }),
  (dispatch: any) => ({
    pushActions: bindPushActions(dispatch),
    basketActions: bindBasketActions(dispatch),
  }),
  NotificationPage,
)
